<template>
  <div
    v-show="text"
    class="seo-text">
    <!--    <game-background-->
    <!--      v-if="activeGame"-->
    <!--      :game-id="activeGame.id"-->
    <!--      class="seo-text__bg" />-->
    <div
      class="seo-text__body">
      <div
        ref="seoContent"
        class="seo-text__content"
        v-html="normalizeText" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { decorateTables } from 'Root/helpers/seo';
import { htmlNormalizeImageRatio } from '../helpers/htmlNormalizer';
// import GameBackground from 'Components/ui/Background/GameBackground';

export default {
  name: 'FooterSeoText',

  // components: { GameBackground },

  props: {
    text: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapState(['activeGame', 'userDevice']),

    normalizeText() {
      return this.text ? htmlNormalizeImageRatio(this.text) : null;
    },
  },

  mounted() {
    this.$nextTick(() => {
      decorateTables(this.$refs.seoContent);
    });
  },
};
</script>

<style lang="scss">
  .seo-text__content {
    @import "../../scss/textBase";

    p, li {
      font-weight: 300;
    }

    p {
      img {
        height: auto;
      }
    }
  }

</style>

<style lang="scss" scoped>
  .seo-text {
    position: relative;
    overflow: hidden;
    background: $color--basic-black;
    content-visibility: auto;
    contain-intrinsic-size: 550px;
  }

  .seo-text__bg {
    opacity: 0.17;
  }

  .seo-text__content {
    //position: relative;
    padding: 23px 0 47px;
    //z-index: 1;
  }

  @media screen and (max-width: 800px) {
    .seo-text__body {
      padding: 0 0 24px;
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .seo-text {
      contain-intrinsic-size: 1000px;
    }
  }
</style>
